import { HttpClient } from 'src/shared/providers/http/http-client';
import { Injectable } from "@angular/core";
import { Aws, S3UploadResponse } from './aws';
import { randomUUID } from '../utils/secure-utils';

@Injectable()
export class IdentificationCheck {

  constructor(
    private httpClient: HttpClient,
    private aws: Aws,
  ) {}

  async getIdentityCheck() {
    return this.httpClient.get('api/v1/homekeeper/identity-check');
  }

  async getBiometricAuth() {
    return this.httpClient.get('api/v1/homekeeper/identity-check/biometric-auth');
  }

  async uploadVideo(videoBlob: Blob): Promise<S3UploadResponse> {
    const filename = `${randomUUID()}.webm`;
    const key = `identity-verification/${filename}`;

    return this.aws.uploadVideoToS3(videoBlob, key);
  }

  async submitVideoUrl(videoUrl: string): Promise<any> {
    return this.httpClient.post('api/v1/homekeeper/identity-check/video', {
      video_url: videoUrl,
    });
  }
}
